import { HcaLibraryResponse, HcaStepId, HcaStepResponse } from '@business/entities/hca_library';
import { Endpoint } from '../endpoint';

export function createStep(step: Partial<HcaStepResponse>) {
  return Endpoint.post<HcaLibraryResponse>(`@makh/hca-step`, { data: { ...step } });
}

export function updateStep(id: HcaStepId, data: Partial<HcaStepResponse>) {
  return Endpoint.patch<HcaLibraryResponse>(`@makh/hca-step/${id}`, { data });
}

export function deleteStep(id: HcaStepId) {
  return Endpoint.delete<HcaLibraryResponse>(`@makh/hca-step/${id}`);
}
